import { Flex } from "@chakra-ui/react";

import FavoriteButton from "components/FavoriteButton/FavoriteButton";
import useRouter from "hooks/useRouter";
import { useTracking } from "contexts/Tracking";
import { setSessionRedirectPage } from "helpers/sessions";
import { useDetailState } from "..";
import { useContactModal } from "modals/useContactModal";
import Button from "components/Chakra/Button";

const StickyContact: React.FC = () => {
  const { id, offer } = useDetailState();
  const { openModal: openContactModal } = useContactModal();

  const { navigateTo } = useRouter();
  const { trackEvent } = useTracking();

  if (!offer || !id) {
    return null;
  }

  const onClickContactButton = () => {
    setSessionRedirectPage(
      `${document.location.origin}/inzerat/${
        offer.seo
      }/${offer?.id?.toString()}`,
    );
    trackEvent({
      "dl.eCat": "offer_detail",
      "dl.eAct": "bttn.clicked",
      "dl.eLab": "Kontaktovat_sticky",
    });
    offer.isContacted
      ? navigateTo("/moje-schranka/[[...messages]]")
      : openContactModal({
          offerId: id,
          isSuspicious: offer.showScamWarning,
          loginEvent: {
            LOGIN: {
              "dl.eAct": "login",
              "dl.eLab": "Odeslání zprávy – detail inzerátu",
              "dl.eCat": "",
            },
            REGISTRATION: {
              "dl.eAct": "registration",
              "dl.eLab": "Odeslání zprávy – detail inzerátu",
              "dl.eCat": "",
            },
          },
        });
  };

  return (
    <Flex
      position="sticky"
      bottom="0"
      justify="space-between"
      align="center"
      p="11px 16px"
      bg="ud-white"
      zIndex="999"
      boxShadow="0px -4px 3px rgba(196, 196, 196, 0.75)"
    >
      <FavoriteButton
        offerId={id}
        withText
        loginEvent={{
          LOGIN: {
            "dl.eAct": "login",
            "dl.eLab": "Uložit inzerát – detail inzerátu - sticky",
            "dl.eCat": "",
          },
          REGISTRATION: {
            "dl.eAct": "registration",
            "dl.eLab": "Uložit inzerát – detail inzerátu - sticky",
            "dl.eCat": "",
          },
        }}
        onRemove={() => {
          trackEvent({
            "dl.eCat": "offer_detail",
            "dl.eAct": "favs.clicked",
            "dl.eLab": "Odebrat_sticky",
          });
        }}
        onAdd={() => {
          trackEvent({
            "dl.eCat": "offer_detail",
            "dl.eAct": "favs.clicked",
            "dl.eLab": "Uložit_sticky",
          });
        }}
      />
      <Button
        variant={offer.isContacted ? "outline" : "unset"}
        trackEventPayload={{
          "dl.eCat": "offer_detail",
          "dl.eAct": "contact.clicked",
          "dl.eLab": "Kontaktovat_sticky",
        }}
        w="60%"
        onClick={() => onClickContactButton()}
      >
        {offer.isContacted ? "Už kontaktováno" : "Kontaktovat"}
      </Button>
    </Flex>
  );
};

export default StickyContact;
